import { SubReason } from "../Components";

export const Subreason = () => {
  return <SubReason />;
};
